module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av203-0799b0c9068b8f9a8f5b1e944be565ab.jpg";